import React, { useState, useEffect , useContext} from "react";
import Scroll from "../../shared/components/navigation/Scroll";
import { AuthContext } from '../../shared/context/auth-context';
import Button from "../../shared/components/formElements/Button";
import SearchBox from "../../customer/components/SearchBox";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "../../shared/hooks/http-hook";
import Table from "../../shared/components/Table/Table";
import { OrderTableHeaders } from "../components/OrderTableHeaders";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import { formatPhoneNumber } from "../../print/page/Print";
import { useWindow } from "../../shared/hooks/window-hook";
import "tachyons";

export const dateHandler = (date) => {
  let dateArray = date.split('-');
  let day = dateArray[2].substring(0,2) ;
  let month = dateArray[1];
  let year = dateArray[0];
return `${month}/${day}/${year}`;
}

const Orders = () => {
  const { width } = useWindow();
  const auth = useContext(AuthContext);
  const [loadedOrders, setLoadedOrders] = useState([]);
  const [LoadArchiveOrder, setLoadArchiveOrder] = useState(false);
  const [searchfield, setSearchfield] = useState("");
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [isPrint, setIsPrint] = useState(true);
  useEffect(() => {
    const fetchOrders = async () => {
      let responseData;
      try {
        responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+"/orders",
          "GET",
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setLoadedOrders(responseData.orders);
      } catch (err) { }
    };
    fetchOrders();
  }, [sendRequest, auth.token]);

  const filteredOrders = loadedOrders.map( order => {
    console.log(order.items[0][0])
    return ({
      id: order.id,
      company: order.items[0][0].company,
      name: order.customer.flat()[0].name,
      lastname: order.customer.flat()[0].lastname,
      rowPhone: order.customer.flat()[0].phone,
      phone: formatPhoneNumber(order.customer.flat()[0].phone),
      cid: order.customer.flat()[0].id,
      startDate: dateHandler(order.startDate),
      // description: (order.description).length > 22 ? ((order.description).slice(0, 20) + "...") : order.description,
      description: order.items[0][0].style.split('/')[0] + " / " +order.items[0][0].company 
        + " / " + order.items[0][0].USSize + " / " + order.items[0][0].color + " / " +order.description ,
      eventDate: dateHandler(order.eventDate),
      orderNumber: order.orderNumber,
      numOfItems: order.items.length,
      deposit: Number(order.deposit).toFixed(2),
      archive: order.archive === false ? 'false' : 'true' 
    })
  }).filter((order) => {
    return (
      String(order.rowPhone).includes(searchfield) ||
      order.orderNumber.toLowerCase().includes(searchfield.toLowerCase())  ||
      order.name.toLowerCase().includes(searchfield.toLowerCase())  ||
      order.lastname.toLowerCase().includes(searchfield.toLowerCase()) ||
      order.startDate.includes(searchfield.toLowerCase())   ||  
      order.eventDate.includes(searchfield.toLowerCase())  ||  
      order.company.toLowerCase().includes(searchfield.toLowerCase()) 
    );
  }).filter((order ) => {
    return(
      LoadArchiveOrder === 'true' ? order.archive === 'true' : order.archive === 'false'
    );       
  }).reverse();

  const onSearchChange = (event) => {
    setSearchfield(event.target.value);
  };

  const onChangeHandler = (event) =>{
    setLoadArchiveOrder(event.target.value)
  }



  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <div className="show-order">
 
      <div class={width > 800 ? "flex justify-between": ""}>
        <div class=" w-25 pa3">
         { isPrint && <label >
            <select onChange={onChangeHandler} className="pa2 bg-light-gray br3">
              <option value= {'false'}  >  Sales</option>
              <option value= {'true'} >Archived Sales</option>
            </select>
          </label>}
        </div>
        <div class=" w-25 pa3">
          { isPrint && <div className="tc">
            <div style={{ display: "inline-block" }}>
              <SearchBox searchChange={onSearchChange} />
            </div>
          </div>}
        </div>
        <div class=" w-25 pa3"  style={{ textAlign: "right" }}>
          {isPrint ? 
          <Button inverse onClick={(e) => {e.preventDefault(); setIsPrint(!isPrint);}}>                
            PRINT
          </Button> :
          <Button inverse onClick={(e) => {e.preventDefault(); setIsPrint(!isPrint); window.print();setIsPrint(!isPrint);}}>                
            🖨️
          </Button>}
        </div>
      </div>
         

    </div>
    <div className=" w-25 ">                   

    </div>



      <Scroll>
          {!isLoading && filteredOrders && (
              <Table headers={OrderTableHeaders} content={filteredOrders} />
           )} 
      </Scroll>
     {width > 800 ? <FloatingButton route={"/orders/new"} /> : ""}
    
    </React.Fragment>
  );
};

export default Orders;
